import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { shipmentsAPI } from "../../../api/shipments/shipments";

const initialState = {
    shipmentBoxes: [],
    boxHasUpdated: false,
    updatedBoxID: null,
    totalWeight: 0,
    statuses: {
        uploading: null,
        updating: null,
        creating: null,
        deletingItem: null,
        creatingBox: null,
        deletingBox: null,
        updatingBox: null,
        updatingDocsWeight: null,
    },
    errors: {
        uploading: null,
        updating: null,
        creating: null,
        deletingItem: null,
        creatingBox: null,
        deletingBox: null,
        updatingBox: null,
        updatingDocsWeight: null,
    },
    popups: {
        create: {
            opened: false,
            data: null,
            boxID: null,
        },
        edit: {
            opened: false,
            data: null,
            boxID: null,
        },
        deleteBox: {
            opened: false,
            boxID: null,
            shipmentID: null,
        },
    },
};

export const uploadShipmentBoxes = createAsyncThunk(
    "shipmentItems/uploadShipmentBoxes",
    async ({ shipmentID }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.uploadShipmentBoxes(shipmentID);
        if (resp.ok) {
            return {
                shipmentBoxes: resp.shipmentBoxes,
            };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);
export const updateShipmentItem = createAsyncThunk(
    "shipmentItems/updateShipmentItem",
    async (
        { shipmentID, shipmentItemID, boxID, data },
        { rejectWithValue }
    ) => {
        if (!boxID) {
            return rejectWithValue({ err: "box id not found" });
        }
        data = {
            "box-id": boxID,
            "en-name": data["en-name"],
            "tr-name": data["tr-name"],
            "original-name": data["original-name"],
            "gtip-code": data["gtip-code"],
            "item-code": +data["item-code"],
            weight: +data["weight"],
            link: data["link"],
            "value-for-one": +data["value-for-one"],
            count: +data["count"],
            warning: data["warning"],
            "country-code": data["country-code"],
        };
        let resp = await shipmentsAPI.updateShipmentItem(
            shipmentID,
            shipmentItemID,
            data
        );
        if (resp.ok) {
            return {
                shipmentItem: resp.shipmentItem,
                boxID: boxID,
            };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);
export const createShipmentItem = createAsyncThunk(
    "shipmentItems/createShipmentItem",
    async ({ shipmentID, boxID, data }, { rejectWithValue }) => {
        if (!boxID) {
            return rejectWithValue({ err: "box id not found" });
        }
        data = {
            "box-id": boxID,
            "en-name": data["en-name"],
            "tr-name": data["tr-name"],
            "original-name": data["original-name"],
            "gtip-code": data["gtip-code"],
            "item-code": +data["item-code"],
            weight: +data["weight"],
            link: data["link"],
            "value-for-one": +data["value-for-one"],
            count: +data["count"],
            warning: data["warning"],
            "country-code": data["country-code"],
        };
        console.log("data: ", data);
        let resp = await shipmentsAPI.createShipmentItem(shipmentID, data);
        if (resp.ok) {
            return {
                shipmentItem: resp.shipmentItem,
                boxID: boxID,
            };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);
export const deleteShipmentItem = createAsyncThunk(
    "shipmentItems/deleteShipmentItem",
    async ({ shipmentID, shipmentItemID, boxID }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.deleteShipmentItem(
            shipmentID,
            shipmentItemID
        );
        if (resp.ok) {
            return {
                ok: true,
                shipmentItemID: shipmentItemID,
                shipmentID,
                boxID,
            };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);
export const createShipmentBox = createAsyncThunk(
    "shipmentItems/createShipmentBox",
    async ({ shipmentID, sizes }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.createShipmentBox(shipmentID, sizes);
        if (resp.ok) {
            return { box: resp.box };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }

        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }

        return rejectWithValue({ err: "something_went_wrong" });
    }
);
export const updateShipmentBox = createAsyncThunk(
    "shipmentItems/updateShipmentBox",
    async ({ shipmentID, boxID, sizes }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.updateShipmentBox(
            shipmentID,
            boxID,
            sizes
        );
        if (resp.ok) {
            return { box: resp.box };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }

        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }

        return rejectWithValue({ err: "something_went_wrong" });
    }
);
export const deleteShipmentBox = createAsyncThunk(
    "shipmentItems/deleteShipmentBox",
    async ({ shipmentID, boxID }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.deleteShipmentBox(shipmentID, boxID);
        if (resp.ok) {
            return { ok: true, boxID: boxID };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);

export const updateDocsWeight = createAsyncThunk(
    "shipmentItems/updateDocsWeight",
    async ({ shipmentID, weight }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.updateShipmentDocsWeight(shipmentID, weight);
        if (resp.ok) {
            return { ok: true, weight: weight};
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
)

const shipmentItemsSlice = createSlice({
    name: "shipmentItems",
    initialState,
    reducers: {
        setShipmentItemsToInitialState(state, action) {
            return initialState;
        },
        openShipmentItemsEditPopup(state, action) {
            let boxID = action.payload.boxID;
            if (!boxID) {
                return;
            }
            state.popups.edit.boxID = boxID;
            state.popups.edit.opened = true;
        },
        openShipmentItemsCreatePopup(state, action) {
            let boxID = action.payload.boxID;
            if (!boxID) {
                return;
            }
            state.popups.create.boxID = boxID;
            state.popups.create.opened = true;
        },
        openDeleteBoxPopup(state, action) {
            let boxID = action.payload.boxID;
            let shipmentID = action.payload.shipmentID;
            if (!boxID || !shipmentID) {
                return;
            }
            state.popups.deleteBox.boxID = boxID;
            state.popups.deleteBox.shipmentID = shipmentID;
            state.popups.deleteBox.opened = true;
        },
        closeShipmentItemsEditPopup(state, action) {
            state.popups.edit.opened = false;
        },
        closeShipmentItemsCreatePopup(state, action) {
            state.popups.create.opened = false;
        },
        closeDeleteBoxPopup(state, action) {
            state.popups.deleteBox.opened = false;
        },
        setShipmentItemsCreatePopupData(state, action) {
            state.popups.create.data = action.payload?.data ?? null;
        },
        setShipmentItemsCreatingStatus(state, action) {
            state.statuses.creating = action.payload.status ?? null;
        },
        setShipmentItemsEditPopupData(state, action) {
            let { data } = action.payload;
            if (!data) {
                return;
            }
            state.popups.edit.data = data;
        },
        setCreatingShipmentBoxStatus(state, action) {
            if (action.payload.status === undefined) {
                state.statuses.creatingBox = null;
                return;
            }

            state.statuses.creatingBox = action.payload.status;
        },
        setBoxHasUpdated(state, action) {
            state.boxHasUpdated = action.payload;
        },
        setErrors(state, action) {
            let errors = action.payload;
            if (!errors) {
                return;
            }
            state.errors = errors;
        },
    },
    extraReducers(builder) {
        //UPLOAD
        builder.addCase(uploadShipmentBoxes.fulfilled, (state, action) => {
            let { shipmentBoxes } = action.payload;
            state.shipmentBoxes = shipmentBoxes;

            state.errors.uploading = null;
            state.statuses.uploading = "fulfilled";
        });
        builder.addCase(uploadShipmentBoxes.pending, (state, action) => {
            state.statuses.uploading = "pending";
            state.errors.uploading = null;
        });
        builder.addCase(uploadShipmentBoxes.rejected, (state, action) => {
            state.statuses.uploading = "rejected";
            if (!action.payload) {
                state.errors.uploading = "something_went_wrong";
                return;
            }

            state.shipmentBoxes = [];
            const { err } = action.payload;
            if (err) {
                state.errors.uploading = action.payload.err;
            }
        });
        //UPDATE
        builder.addCase(updateShipmentItem.fulfilled, (state, action) => {
            let { shipmentItem, boxID } = action.payload;

            let boxFromState = state.shipmentBoxes.find(
                (box) => box.id === boxID
            );
            if (!shipmentItem || !boxID || !boxFromState) {
                state.errors.creating = "something_went_wrong";
                state.statuses.creating = "rejected";
                return;
            }

            let index = boxFromState.items.findIndex(
                (stateShipmentItem) => stateShipmentItem.id === shipmentItem.id
            );
            if (index < 0) {
                state.errors.updating = "something_went_wrong";
                state.statuses.updating = "rejected";
                return;
            }

            boxFromState.items[index] = shipmentItem;

            state.errors.updating = null;
            state.statuses.updating = "fulfilled";
        });
        builder.addCase(updateShipmentItem.pending, (state, action) => {
            state.statuses.updating = "pending";
            state.errors.updating = null;
        });
        builder.addCase(updateShipmentItem.rejected, (state, action) => {
            state.statuses.updating = "rejected";
            if (!action.payload) {
                state.errors.updating = "something_went_wrong";
                return;
            }
            const { err } = action.payload;
            if (err) {
                state.errors.updating = err;
            }
        });
        //CREATE
        builder.addCase(createShipmentItem.fulfilled, (state, action) => {
            let { shipmentItem, boxID } = action.payload;

            let boxFromState = state.shipmentBoxes.find(
                (box) => box.id === boxID
            );
            if (!shipmentItem || !boxID || !boxFromState) {
                state.errors.creating = "something_went_wrong";
                state.statuses.creating = "rejected";
                return;
            }

            if (!boxFromState.items) boxFromState.items = [];

            boxFromState.items.push(shipmentItem);

            state.errors.creating = null;
            state.statuses.creating = "fulfilled";
        });
        builder.addCase(createShipmentItem.pending, (state, action) => {
            state.statuses.creating = "pending";
            state.errors.creating = null;
        });
        builder.addCase(createShipmentItem.rejected, (state, action) => {
            state.statuses.creating = "rejected";
            if (!action.payload) {
                state.errors.creating = "something_went_wrong";
                return;
            }
            const { err } = action.payload;
            if (err) {
                state.errors.creating = err;
            }
        });
        // DELETE ITEM
        builder.addCase(deleteShipmentItem.fulfilled, (state, action) => {
            let { shipmentItemID, boxID } = action.payload;
            let boxFromState = state.shipmentBoxes.find(
                (box) => box.id === boxID
            );

            if (!shipmentItemID || !boxID || !boxFromState) {
                state.errors.creating = "something_went_wrong";
                state.statuses.creating = "rejected";
                return;
            }

            let index = boxFromState.items.findIndex(
                (stateShipmentItem) => stateShipmentItem.id === shipmentItemID
            );
            if (index < 0) {
                state.errors.updating = "something_went_wrong";
                state.statuses.updating = "rejected";
                return;
            }

            boxFromState.items?.splice(index, 1);
            state.statuses.deletingItem = "fulfilled";
            state.errors.deletingItem = null;
        });
        builder.addCase(deleteShipmentItem.pending, (state, action) => {
            state.statuses.deletingItem = "pending";
            state.errors.deletingItem = null;
        });
        builder.addCase(deleteShipmentItem.rejected, (state, action) => {
            state.statuses.deletingItem = "rejected";
            let err = action.payload?.err ?? "something_went_wrong";
            if (err === "unauthorized") {
                return;
            }
            state.statuses.deletingItem = "rejected";
            state.errors.deletingItem = err;
        });
        //CREATE BOX
        builder.addCase(createShipmentBox.fulfilled, (state, action) => {
            let { box } = action.payload;
            if (!box) {
                state.errors.creatingBox = "something_went_wrong";
                state.statuses.creatingBox = "rejected";
            }

            state.errors.creatingBox = null;
            state.statuses.creatingBox = "fulfilled";
            state.shipmentBoxes.push(box);
        });
        builder.addCase(createShipmentBox.pending, (state, action) => {
            state.errors.creatingBox = null;
            state.statuses.creatingBox = "pending";
        });
        builder.addCase(createShipmentBox.rejected, (state, action) => {
            state.statuses.creatingBox = "rejected";
            if (!action.payload) {
                state.errors.creatingBox = "something_went_wrong";
                return;
            }
            const { err } = action.payload;
            if (err) {
                state.errors.creatingBox = err;
            }
        });
        //UPDATE BOX
        builder.addCase(updateShipmentBox.fulfilled, (state, action) => {
            let { box } = action.payload;
            if (!box) {
                state.errors.updatingBox = "something_went_wrong";
                state.statuses.updatingBox = "rejected";
            }

            let index = state.shipmentBoxes.findIndex(
                (stateBox) => stateBox.id === box.id
            );
            if (index < 0) {
                state.statuses.updatingBox = "rejected";
                state.errors.updatingBox = "something_went_wrong";
                return;
            }

            state.shipmentBoxes[index] = box;
            state.boxHasUpdated = true;
            state.errors.updatingBox = null;
            state.statuses.updatingBox = "fulfilled";
            state.updatedBoxID = box.id;
            state.boxHasUpdated = true;
        });
        builder.addCase(updateShipmentBox.pending, (state, action) => {
            state.errors.updatingBox = null;
            state.statuses.updatingBox = "pending";
        });
        builder.addCase(updateShipmentBox.rejected, (state, action) => {
            state.statuses.updatingBox = "rejected";
            if (!action.payload) {
                state.errors.updatingBox = "something_went_wrong";
                return;
            }
            const { err } = action.payload;
            if (err) {
                state.errors.updatingBox = err;
            }
        });
        //DELETE BOX
        builder.addCase(deleteShipmentBox.fulfilled, (state, action) => {
            let boxID = action.payload.boxID;
            let index = state.shipmentBoxes.findIndex(
                (box) => box.id === boxID
            );
            if (index < 0) {
                state.statuses.deletingBox = "rejected";
                state.errors.deletingBox = "something_went_wrong";
                return;
            }

            state.shipmentBoxes.splice(index, 1);
            state.statuses.deletingBox = "fulfilled";
            state.errors.deletingBox = null;
        });
        builder.addCase(deleteShipmentBox.pending, (state, action) => {
            state.statuses.deletingBox = "pending";
            state.errors.deletingBox = null;
        });
        builder.addCase(deleteShipmentBox.rejected, (state, action) => {
            state.statuses.deletingBox = "rejected";
            let err = action.payload?.err ?? "something_went_wrong";
            if (err === "unauthorized") {
                return;
            }
            state.statuses.deletingBox = "rejected";
            state.errors.deletingBox = err;
        });
        //UPDATE docsWeight
        builder.addCase(updateDocsWeight.fulfilled, (state, action) => {
            let { weight } = action.payload;
            if (!weight || !state.shipmentBoxes || !state.shipmentBoxes.length) {
                state.errors.updatingDocsWeight = "something_went_wrong";
                state.statuses.updatingDocsWeight = "rejected";
            }

            state.shipmentBoxes[0].weight = weight;
            state.statuses.updatingDocsWeight = "fulfilled"
            state.errors.updatingDocsWeight = null
        });
        builder.addCase(updateDocsWeight.pending, (state, action) => {
            state.errors.updatingDocsWeight = null;
            state.statuses.updatingDocsWeight = "pending";
        });
        builder.addCase(updateDocsWeight.rejected, (state, action) => {
            state.statuses.updatingDocsWeight = "rejected";
            if (!action.payload) {
                state.errors.updatingDocsWeight = "something_went_wrong";
                return;
            }
            const { err } = action.payload;
            if (err) {
                state.errors.updatingDocsWeight = err;
            }
        });

    },
});

export default shipmentItemsSlice.reducer;
export const {
    setShipmentItemsToInitialState,
    openShipmentItemsCreatePopup,
    openShipmentItemsEditPopup,
    openDeleteBoxPopup,
    closeShipmentItemsCreatePopup,
    closeShipmentItemsEditPopup,
    closeDeleteBoxPopup,
    setShipmentItemsCreatePopupData,
    setShipmentItemsCreatingStatus,
    setShipmentItemsEditPopupData,
    setCreatingShipmentBoxStatus,
    setBoxHasUpdated,
    setErrors,
} = shipmentItemsSlice.actions;

export const selectShipmentBoxes = (state) => state.shipmentItems.shipmentBoxes;

export const selectShipmentItemsUploadingStatus = (state) =>    state.shipmentItems.statuses.uploading;
export const selectShipmentItemsUploadingError = (state) =>     state.shipmentItems.errors.uploading;

export const selectShipmentItemsEditPopup = (state) =>  state.shipmentItems.popups.edit;
export const selectShipmentItemsCreatePopup = (state) =>    state.shipmentItems.popups.create;
export const selectDeleteBoxPopup = (state) =>  state.shipmentItems.popups.deleteBox;

export const selectShipmentItemsUpdatingStatus = (state) =>     state.shipmentItems.statuses.updating;
export const selectShipmentItemsCreatingStatus = (state) =>     state.shipmentItems.statuses.creating;
export const selectShipmentItemDeletingStatus = (state) =>  state.shipmentItems.statuses.deletingItem;

export const selectUpdatedBoxID = (state) => state.shipmentItems.updatedBoxID;
export const selectBoxHasUpdated = (state) => state.shipmentItems.boxHasUpdated;

export const selectCreatingBoxStatus = (state) =>   state.shipmentItems.statuses.creatingBox;
export const selectShipmentBoxUpdatingStatus = (state) =>   state.shipmentItems.statuses.updatingBox;
export const selectShipmentBoxDeletingStatus = (state) =>   state.shipmentItems.statuses.deletingBox;

export const selectUpdatingDocsWeightStatus = (state) => state.shipmentItems.statuses.updatingDocsWeight;
export const selectUpdatingDocsWeightError = (state) => state.shipmentItems.errors.updatingDocsWeight;

export const selectAllShipmentItemsErrors = (state) =>
    state.shipmentItems.errors;
